"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageNotFound = void 0;
var react_1 = require("@chakra-ui/react");
var react_2 = __importDefault(require("react"));
var PageNotFound = function () {
    return (react_2.default.createElement(react_1.Box, { textAlign: "center", padding: "3rem", marginX: "auto", maxWidth: "880px", borderColor: "#ebd31b", borderWidth: "5px", borderRadius: "10px", backgroundColor: "#fff" },
        react_2.default.createElement(react_1.Text, null, "\u8A72\u5F53\u306E\u30DA\u30FC\u30B8\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002"),
        react_2.default.createElement(react_1.Box, { mt: "3rem" },
            react_2.default.createElement(react_1.Button, { as: "a", href: "/main", color: "white", bg: "#F9B812", size: "lg", height: "4rem", fontSize: "1.6rem", minW: "10rem", _hover: {
                    color: "white",
                    backgroundColor: "#D59D0F",
                    textDecoration: "none",
                }, _active: {
                    color: "white",
                    backgroundColor: "#BF8D0D",
                } }, "\u30C8\u30C3\u30D7\u30DA\u30FC\u30B8\u306B\u623B\u308B"))));
};
exports.PageNotFound = PageNotFound;
